import script from "./GmxTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./GmxTextArea.vue?vue&type=script&setup=true&lang=js"

import "./GmxTextArea.vue?vue&type=style&index=0&id=ca20ae90&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca20ae90"]])

export default __exports__